export const iconOptionsStandFor = [
  { value: 'Shield', label: 'Shield' },
  { value: 'DollarSign', label: 'DollarSign' },
  { value: 'TrendingUp', label: 'TrendingUp' },
  { value: 'Users', label: 'Users' },
  { value: 'FileText', label: 'FileText' },
  { value: 'Calendar', label: 'Calendar' },
];

export const iconOptionsCoverage = [
  { value: 'Building2', label: 'Building2' },
  { value: 'Layers', label: 'Layers' },
  { value: 'Hospital', label: 'Hospital' },
  { value: 'GraduationCap', label: 'GraduationCap' },
  { value: 'Shield', label: 'Shield' },
  { value: 'Landmark', label: 'Landmark' },
  { value: 'BusFront', label: 'BusFront' },
  { value: 'Trees', label: 'Trees' },
];
